import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

export const Hero = () => {
  const { t } = useTranslation();
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" aria-label={t('hero.section_label','Hero section')}>
      {/* Video Background with Overlay */}
      <div className="absolute inset-0 z-0" aria-hidden="true">
        <video
          autoPlay
          muted
          loop
          playsInline
          poster="/images/hero/hero-poster.jpg"
          className="w-full h-full object-cover filter grayscale"
        >
          <source src="/videos/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl text-center md:text-left rtl:md:text-right"
        >
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6">
            <Trans 
              i18nKey="hero.title" 
              components={{
                strong: <span className="text-brand-turquoise" />
              }}
            />
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8">
            {t("hero.subtitle")}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start rtl:md:justify-end">
            <Button
              asChild
              size="lg"
              className="bg-brand-turquoise hover:bg-teal-700 text-white"
            >
              <a href="#contact">{t("cta")}</a>
            </Button>
            <Button
              asChild
              size="lg"
              className="bg-brand-turquoise hover:bg-teal-700 text-white"
            >
              <a href="#process">{t("hero.secondary_cta")}</a>
            </Button>
          </div>
        </motion.div>

      </div>

      {/* Scroll Indicator */}
      <motion.div
        animate={{ y: [0, 10, 0] }}
        transition={{ repeat: Infinity, duration: 2 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <ChevronDown className="w-8 h-8 text-white" aria-hidden="true" />
      </motion.div>
    </section>
  );
};
